(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Web3SignatureProvider", [], factory);
	else if(typeof exports === 'object')
		exports["Web3SignatureProvider"] = factory();
	else
		root["Web3SignatureProvider"] = factory();
})(self, () => {
return 